import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=cd35a224&"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports